import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TagModel} from "../models/tag.model";
import {TagType} from "../types/tag.type";

@Injectable({providedIn: 'root'})
export class TagsHttpService {

  private base_url = `/tags`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: any): Observable<{ cursor: string, list: TagModel[] }> {
    return this.http
      .get<{ cursor: string, list: TagModel[] }>(this.base_url, {params});
  }

  get(tagId: string): Observable<TagModel> {
    return this.http
      .get<TagModel>(`${this.base_url}/${tagId}`);
  }

  create(tag: TagModel): Observable<TagModel> {
    return this.http
      .put<TagModel>(this.base_url, tag);
  }

  update(tagId: string, tag: TagModel): Observable<TagModel> {
    return this.http
      .post<TagModel>(`${this.base_url}/${tagId}`, tag);
  }

  delete(tagId: string, shouldMask: boolean): Observable<TagModel> {
    return this.http
      .delete<TagModel>(`${this.base_url}/${tagId}`, {params: {shouldMask: shouldMask}});
  }

  getAllByTypes(types: string[]): Observable<{ cursor: string, list: TagModel[] }> {
    return this.http
      .get<{ cursor: string, list: TagModel[] }>(this.base_url, {params: {type: types}});
  }

  getTagsByName(names: string[], type: TagType): Observable<TagModel[]> {
    return this.http
      .get<TagModel[]>(this.base_url, {params: {type: type, names: names}});
  }
}
